module.exports = __webpack_public_path__ + "static/media/empty.a63d8f89.png";